import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isLoggedIn } from '../utils/utilities';
import { CFade } from '@coreui/react';

const PublicRoute = ({ component: Component, restricted, ...rest }) => {
  return (
    // restricted = false meaning public route
    // restricted = true meaning restricted route
    <Route
      {...rest}
      render={props =>
        isLoggedIn() && restricted ? (
          <CFade>
            <Redirect to="/dashboard" />
          </CFade>
        ) : (
          <CFade>
            <Component {...props} />
          </CFade>
        )
      }
    />
  );
};

export default PublicRoute;
